import React__default, { useState } from 'react';
import { Toast } from './Toast.es.js';
import { useTransition, animated } from 'react-spring';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextMobile = React__default.createContext({});
const ToastProviderMobile = ({
  children
}) => {
  const [toastProps, setToastProps] = useState(null);
  const open = (props) => {
    if (toastProps && JSON.stringify(toastProps) === JSON.stringify(props)) {
      return;
    }
    setToastProps(props);
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  const onClose = () => setToastProps(null);
  const transitions = useTransition(toastProps, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 125, friction: 20, precision: 0.1 }
  });
  return /* @__PURE__ */ React__default.createElement(ToastContextMobile.Provider, {
    value: toast
  }, children, toastProps && transitions((style, item) => item && /* @__PURE__ */ React__default.createElement(animated.div, {
    style
  }, /* @__PURE__ */ React__default.createElement(Toast, __spreadProps(__spreadValues({}, item), {
    onClose
  })))));
};

export { ToastContextMobile, ToastProviderMobile };
